import { useState } from 'react';

const services = [
  {
    icon: '§',
    title: 'E-Commerce Buchführung',
    description: 'Umfassende Betreuung und Unterstützung für Onlinehändler u.a. in den Bereichen:',
    features: ['Lohn- und Finanzbuchführung', 'GoBD-Konformität', 'Umsatzsteuervoranmeldung', 'Betriebsprüfungen']
  },
  {
    icon: 'ri-global-line',
    title: 'Internationale Umsatzsteuer',
    description: 'Gemeinsam mit unserer Partner-Steuerberaterin Sandra Hommen und unserem Netzwerk internationaler Steuerberatungen unterstützen wir Sie u.a. bei folgenden Themen:',
    features: ['OSS-Meldungen', 'Umsatzsteuerliche Registrierungen im EU-Ausland', 'Drittstaaten-Handel', 'Compliance-Management']
  }, 
  {
    icon: 'ri-file-list-3-line',
    title: 'Compliance & Reporting',
    description: 'Unterstützung bei der vollständigen Erfüllung aller rechtlichen Meldepflichten mit transparentem Reporting und proaktiver Kommunikation.',
    features: ['Auf Ihr Geschäftsmodell angepasste Controlling-Berichte', 'Innergemeinschaftliche Verbringungen und Erwerbe', 'Intrastat-Meldungen', 'Jahresabschlüsse']
  },  
  {
    icon: 'ri-amazon-line',
    title: 'Amazon International',
    description: 'Spezialisierte Beratung für Amazon-Händler: Von AFN und MFN hin zu AGL, CEE, PAN-EU oder auch VCS, wir sprechen Ihre Sprache:',
    features: ['Korrekte Zuordnung aller Zahlungsein- und -ausgänge zu Ihren Ausgangsbelegen', 'Einzeltransaktionsbasierte Ermittlung Ihrer Amazon-Gebühren', 'Erstellung von Verbringungslisten und Proforma-Rechnungen', 'Auf Wunsch detailliertes Amazon-Reporting']
  },
  {
    icon: 'ri-store-2-line',
    title: 'Shopify & Marktplätze',
    description: 'Professionelle und prozessoptimierte Integration aller gängigen Vertriebskanäle, Zahlungsanbieter und ERP-Systeme in Ihre Buchführung:',
    features: ['Shopify-Integration', 'Otto, eBay, Kaufland, Mirakl-basierte Marktplätze und mehr', 'Amazon Pay, Klarna, Mollie, PayPal, Stripe', 'vollumfängliche und verprobte Verbuchung aller Erlös- und Zahlungsdaten']
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Wachstum und Skalierbarkeit',
    description: 'Unterstützung bei der strategischen Planung von E-Commerce Unternehmen: Treffen Sie Entscheidungen auf Basis detaillierter Zahlen und auf Ihr Geschäftsmodell abgestimmter Auswertungen.',
    features: ['Betriebswirtschaftliche Auswertungen', 'Maßgeschneiderte Controlling-Berichte ', 'Planungssicherheit und Skalierbarkeit', 'Kosten optimieren, Ertrag maximieren']
  }
];

export default function Services() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-[#FF6B35] font-semibold text-sm uppercase tracking-wider">Unsere Expertise</span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#2F4858] mt-4 mb-6">
            Vollumfängliche und ordnungsgemäße Buchführung
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Als spezialisierter Dienstleister für Buchführung und Compliance im E-Commerce bieten wir maßgeschneiderte Lösungen für alle Aspekte Ihres Online-Geschäfts. Von der Gründung bis zur internationalen Expansion begleiten wir Sie mit fundierter Expertise.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 cursor-pointer group"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className={`w-16 h-16 flex items-center justify-center rounded-2xl mb-6 transition-all duration-300 ${
                hoveredIndex === index ? 'bg-[#FF6B35]' : 'bg-[#2F4858]'
              }`}>
                {index === 0 ? (
                  <span className="text-4xl text-white font-bold">&#167;</span>
                ) : (
                  <i className={`${service.icon} text-3xl text-white`}></i>
                )}
              </div>
              <h3 className="text-xl font-bold text-[#2F4858] mb-4 group-hover:text-[#FF6B35] transition-colors">
                {service.title}
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-[#FF6B35] mr-2 text-lg"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}